import React from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

type Variant = 'top' | 'right' | 'bottom' | 'left';

interface CustomTooltipProps extends Omit<TooltipProps, 'placement'> {
  variant?: Variant;
  offset?: [number, number];
  width?: number | string;
  height?: number | string;
  bgColor?: string;
  textColor?: string;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  variant = 'top',
  offset = [0, 8],
  width,
  height,
  children,
  title,
  bgColor = 'white',
  textColor = '#666',
  ...props
}) => {
  const placementMap: Record<Variant, TooltipProps['placement']> = {
    top: 'top',
    right: 'right',
    bottom: 'bottom',
    left: 'left',
  };

  return (
    <Tooltip
      title={title}
      placement={placementMap[variant]}
      arrow
      PopperProps={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset,
            },
          },
        ],
      }}
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: bgColor,
            color: textColor,
            fontSize: '0.875rem',
            borderRadius: 2,
            border: '1px solid #e0e0e0',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            px: 2,
            py: 1.5,
            lineHeight: 1.4,
            maxWidth: 800,
            ...(width ? { width } : {}),
            ...(height ? { height } : {}),
            '& .MuiTooltip-arrow': {
              color: 'white',
              '&::before': {
                border: '1px solid #e0e0e0',
              },
            },
          },
        },
      }}
      {...props}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
